import { createAsyncThunk } from "@reduxjs/toolkit";
import http from "../../../utils/http";
import {
  ForgetPasswordPayload,
  LoginPayload,
  ResetPasswordPayload,
} from "./types";
const BaseURL = process.env.REACT_APP_API_URL;

export const loginAction = createAsyncThunk(
  "organisation/login",
  async (payload: LoginPayload, { rejectWithValue }) => {
    try {
      const res = await http.post({
        url: `${BaseURL}/auth/partner-login`,
        body: payload,
      });

      return res;
    } catch (err: any) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const forgotPasswordAction = createAsyncThunk(
  "auth/forgot_password",
  async (payload: ForgetPasswordPayload, { rejectWithValue }) => {
    try {
      const { email, platform } = payload;
      const response = http.get({
        url: `${BaseURL}/auth/forgot-org-password/${email}`,
      });
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const resetPasswordAction = createAsyncThunk(
  "auth/reset_password",
  async (payload: ResetPasswordPayload, { rejectWithValue }) => {
    try {
      const response = http.post({
        url: `${BaseURL}/auth/reset-org-password`,
        body: payload,
      });

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);
